import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    allTab: 'All',
    sortTop: 'Most opened',
    sortPrice: 'By price',
    sortNew: 'New',
  },
  ru: {
    allTab: 'Все',
    sortTop: 'Топ открытий',
    sortPrice: 'По цене',
    sortNew: 'Новые',
  },
  uz: {
    allTab: 'Hammasi',
    sortTop: 'Eng koʻp ochilgan',
    sortPrice: 'Narx boʻyicha',
    sortNew: 'Yangi',
  },
  fa: {
    allTab: 'همه',
    sortTop: 'پربازترین',
    sortPrice: 'بر اساس قیمت',
    sortNew: 'جدید',
  },
  pt: {
    allTab: 'Todas',
    sortTop: 'Mais abertas',
    sortPrice: 'Por preço',
    sortNew: 'Novas',
  },
  tr: {
    allTab: 'Tümü',
    sortTop: 'En çok açılan',
    sortPrice: 'Fiyata göre',
    sortNew: 'Yeni',
  },
  uk: {
    allTab: 'Усі',
    sortTop: 'Топ відкриттів',
    sortPrice: 'За ціною',
    sortNew: 'Нові',
  },
  de: {
    allTab: 'Alle',
    sortTop: 'Meist geöffnet',
    sortPrice: 'Nach Preis',
    sortNew: 'Neu',
  },
  es: {
    allTab: 'Todas',
    sortTop: 'Más abiertas',
    sortPrice: 'Por precio',
    sortNew: 'Nuevas',
  },
  pl: {
    allTab: 'Wszystkie',
    sortTop: 'Najczęściej otwierane',
    sortPrice: 'Po cenie',
    sortNew: 'Nowe',
  },
});
